import { IEnvironment } from "./environment.interface";

export const environment: IEnvironment = {
  production: true,
  envName: 'prod',
  baseUrl: 'https://api.vergleichsofferten.ch',
  apiV1: 'api/v1/',
  uiDomain: 'https://app.vergleichsofferten.ch',
  apiDomain: 'https://api.vergleichsofferten.ch',
  googleMapsApiKey: '',

  firebase: {
    apiKey: "AIzaSyAjLVYGBqj1lElLisVS0yXf9eriHh-AqT8",
    authDomain: "vergleichsofferte.firebaseapp.com",
    projectId: "vergleichsofferte",
    storageBucket: "vergleichsofferte.firebasestorage.app",
    messagingSenderId: "822348852511",
    appId: "1:822348852511:web:f0e38316c1bf6b781dd42a",
    measurementId: "G-DREHYN5L7L"
  },
};
